import React from 'react';
import { InfoPopover } from '../../HoverPopover/InfoPopover';

export const P90_TOOLTIP =
  'P90 means: 90% of runs are faster than this value. Click for more.';
export const P90_TOOLTIP_URL = 'https://docs.hud.io/docs/p90';

export function P90InfoHover() {
  return <InfoPopover body={P90_TOOLTIP} href={P90_TOOLTIP_URL} />;
}
